export const getValidationStatus = (data: any, error: any, names: string[]) => {
	for (let name of names) {
		if (!data[name] || error[name]) return false;
	}
	return true;
};
